import React, { useContext, useState, useEffect, useRef } from "react"
import styled from "styled-components"
import media from "cssMix/index"
import { useTranslation } from "react-i18next"
import { ContextStore } from "Reducer"
import { Map } from "immutable"
import { useHistory } from "react-router-dom"
import MenuPopupModal from "./MenuPopupModal"
import { IoCloseSharp } from "react-icons/io5"

// api
import { getUserInfo } from "api"

// comp
import Logo from "./Logo"
import Account from "./Account"
import NewMenu from "./NewMenu"

import useMediaQuery from "useHooks/useMediaQuery"

export default ({ homeScrollTop }) => {
  const [popOpen, setPopOpen] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [isHamOpen, setIsHamOpen] = useState(false)
  const {
    state: { stateReducer },
    dispatch,
  } = useContext(ContextStore)
  const userInfo = stateReducer.get("userInfo", Map())
  const { mediaType } = useMediaQuery()
  const account = userInfo.get("account", "")
  const balance = Number(userInfo.get("balance", 0)).toLocaleString()
  const currency = userInfo.get("currency", "")
  const mainAreaRoute = stateReducer.get("mainAreaRoute")
  const payoutRank = stateReducer.get("payoutRank")
  const history = useHistory()
  const { t } = useTranslation()
  const popRef = useRef()
  const iconRef = useRef()

  useEffect(() => {
    if (!refresh) return
    setTimeout(() => {
      setRefresh(false)
    }, 1000)
  }, [refresh])

  const handlePopClick = () => {
    setPopOpen((preVal) => !preVal)
  }

  const handleRefreshClick = () => {
    if (refresh) return
    setRefresh(true)
    getUserInfo(dispatch, history)
  }

  const hamHandler = () => {
    setIsHamOpen(!isHamOpen)
  }
  return (
    <Nav mainAreaRoute={mainAreaRoute} payoutRankSize={payoutRank.size}>
      <Logo
        t={t}
        hamHandler={hamHandler}
        balance={balance}
        handleRefreshClick={handleRefreshClick}
        refresh={refresh}
        currency={currency}
        userInfo={userInfo}
        account={account}
        dispatch={dispatch}
        mainAreaRoute={mainAreaRoute}
        homeScrollTop={homeScrollTop}
      />

      {mediaType === "pc" ? (
        <>
          <Account
            t={t}
            account={account}
            balance={balance}
            currency={currency}
            refresh={refresh}
            handleRefreshClick={handleRefreshClick}
            dispatch={dispatch}
            userInfo={userInfo}
          />
          <NewMenu t={t} mainAreaRoute={mainAreaRoute} dispatch={dispatch} />
        </>
      ) : (
        <MenuPopupModal
          isOpen={isHamOpen}
          onModalClose={() => setIsHamOpen(false)}
          justify={"flex-end"}
        >
          <PopupMenu>
            <IoCloseSharp onClick={hamHandler} />
            <Account
              t={t}
              popOpen={popOpen}
              account={account}
              balance={balance}
              currency={currency}
              refresh={refresh}
              handlePopClick={handlePopClick}
              handleRefreshClick={handleRefreshClick}
              popRef={popRef}
              iconRef={iconRef}
              dispatch={dispatch}
              userInfo={userInfo}
            />
            <NewMenu
              t={t}
              mainAreaRoute={mainAreaRoute}
              dispatch={dispatch}
              hamHandler={hamHandler}
            />
          </PopupMenu>
        </MenuPopupModal>
      )}
    </Nav>
  )
}

const PopupMenu = styled.div`
  position: absolute;
  width: 40%;
  height: 100%;
  min-width: 290px;
  z-index: 100;
  box-sizing: border-box;
  box-shadow: -1px 0 0 0 #5429af;
  background-image: linear-gradient(to bottom, #1e1c6c, #1e1459 48%, #322257);
  padding: 40px 25px 0;
  & > svg {
    width: 28px;
    height: 28px;
    position: absolute;
    top: 12px;
    right: 15px;
    color: #fff;
    cursor: pointer;
  }
`
const Nav = styled.div`
  background: ${({ theme }) => theme.navBackground};
  box-sizing: border-box;
  padding: 70px 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 260px;
  flex-shrink: 0;
  border-right: 1px solid #5429af;
  overflow-y: overlay;
  > input {
    width: 100%;
    box-sizing: border-box;
    height: 0;
    visibility: hidden;
    background: transparent;
    font-size: 16px;
    color: #ffffff;
    display: none;
    ${media.tablet`
    display:block;  
`}
  }
  ${media.tablet`
    ${(props) =>
      props.mainAreaRoute === "Lobby"
        ? props.payoutRankSize > 0
          ? `height:180px`
          : ""
        : props.mainAreaRoute === "PayoutRank" ||
          props.mainAreaRoute === "PlayerRank"
        ? "height:125px"
        : ""};
    background:none;
    align-self: stretch;
    padding:0 16px;
    position:relative;
    background-size:cover;
    width:100%;
    max-width:none;

`}
  ${media.mobile`
    `}


.grow-height-enter {
    height: 0;
    padding: 0;
    border: 0;
    visibility: hidden;
    border: 0;
    margin: 0;
  }
  .grow-height-enter-active {
    padding: 14px;
    height: 50px;
    transition: 200ms;
    visibility: visible;
    margin-bottom: 7px;
    border: 1px solid #ffffff;
  }
  .grow-height-enter-done {
    padding: 14px;
    height: 50px;
    transition: 200ms;
    visibility: visible;
    margin-bottom: 7px;
    border: 1px solid #ffffff;
  }
  .grow-height-exit {
    padding: 14px;
    height: 50px;
    visibility: visible;
    border: 1px solid #ffffff;
    margin-bottom: 7px;
  }

  .grow-height-exit-active {
    height: 0;
    padding: 0;
    transition: 200ms;
    visibility: hidden;
    margin: 0;
    border: 0;
  }
`
